import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { ContentBaseModel } from '@libs/cms/models';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.content]': 'isContent',
    '[class.box]': '!!data().view?.box',
    '[class.spacing]': '!!data().view?.spacing',
  },
})
export class ContentBaseComponent<T extends ContentBaseModel = ContentBaseModel> {
  public data: InputSignal<T> = input.required();
  public readonly isContent: boolean = true;
}
